import FireflyParticle from './FireflyParticle';

export default class FirefliesController {
  constructor(game, location) {
    this.game = game;
    this.location = location;

    //
    this.fireflies = [];
    // add 4 fireflies
    for (let i = 0; i < 4; i++) {
      const firefly = this.location.addFurniture({ id: 'firefly', x: 0, y: 0 });
      firefly.controller = this; // set reference to this controller
      this.fireflies.push(firefly);
    }

    // glows
    this.glows = [];
    this.glowsPool = [];
  }

  showFireflies() {
    for (let i = 0; i < this.fireflies.length; i++) {
      this.fireflies[i].enterLocation();
    }
  }

  hideFireflies() {
    for (let i = 0; i < this.fireflies.length; i++) {
      this.fireflies[i].exitLocation();
    }
    this.onBreakPair();
  }

  tryToPair(firefly) {
    if (firefly.canBePaired()) {
      for (let i = 0; i < this.fireflies.length; i++) {
        const ff = this.fireflies[i];
        if (ff.canBePaired() && ff !== firefly) {
          // calculate distance
          const dx = firefly.x - ff.x;
          const dy = firefly.y - ff.y;
          const dist = dx * dx + dy * dy;
          if (dist < 50 * 50) {
            firefly.setPair(ff, true); // this is guide
            ff.setPair(firefly, false); // this follows the guide
            this.showGlow();
          }
        }
      }
    }
  }

  // called on break pair of fireflies
  onBreakPair() {
    this.isGlow = false;
  }

  handleGlowComplete(glow) {
    if (this.isGlow) {
      // glow again
      const x = Phaser.Math.between(100, this.location.width - 100);
      const y = Phaser.Math.between(100, 720 - 100);
      glow.init(x, y);
    } else {
      // remove glow
      glow.parent.removeChild(glow);
      const ind = this.glows.indexOf(glow);
      this.glows.splice(ind, 1);
    }
  }

  getGlow() {
    if (this.glowsPool.length > 0) {
      return this.glowsPool.shift();
    } else {
      const glow = new FireflyParticle(this.game, 0, 0);
      glow.onComplete.add(this.handleGlowComplete, this);
      return glow;
    }
  }

  showGlow() {
    this.isGlow = true;
    if (this.glows.length < 50) {
      const len = 50 - this.glows.length;
      for (let i = 0; i < len; i++) {
        const glow = this.getGlow();
        this.location.midground.addChild(glow);
        const x = Phaser.Math.between(100, this.location.width - 100);
        const y = Phaser.Math.between(100, 720 - 100);
        glow.init(x, y, i * 10);
        this.glows.push(glow);
      }
    }

    this.game.sounds.playSFX('item_firefly', { spriteID: 'sfx' });
  }
}
